export class UserModel {
    user: {
        userId: number;
        userName: string;
        companyName: string;
        active: boolean;
        plataformName: string;
    };
  highlighted?: boolean;
  hovered?: boolean;
}
